module.exports = __webpack_public_path__ + "img/ctrl-p-stub-0.f408e1d0.svg";